import *  as service from '../services/LoginServices';

import {
    defaultPianoTechCompany,
    MAINTENANCE_TYPE_ADD,
    MAINTENANCE_TYPE_EDIT,
} from '../app-constants';

export const LOGIN_VALIDATE_USER_START = 'LOGIN_VALIDATE_USER_START';
export const LOGIN_VALIDATE_USER_SUCCESS = 'LOGIN_VALIDATE_USER_SUCCESS';
export const LOGIN_VALIDATE_USER_FAILURE = 'LOGIN_VALIDATE_USER_FAILURE';
export const LOGIN_USER_MODIFIED = 'LOGIN_USER_MODIFIED';
export const LOGIN_PASSWORD_MODIFIED = 'LOGIN_PASSWORD_MODIFIED';

function validateUserSucceeded(response, loginId) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: LOGIN_VALIDATE_USER_FAILURE,
            message: errorMessage,
        }
    }

    let pianoTechCompany = defaultPianoTechCompany;
    pianoTechCompany.userId = loginId;

    let maintenanceType = MAINTENANCE_TYPE_ADD;

    if (jsonResponse.pianoTechCompany) {
        pianoTechCompany = jsonResponse.pianoTechCompany;
        maintenanceType = MAINTENANCE_TYPE_EDIT;
    }

    const pianoTechnicianList = jsonResponse.pianoTechnicianList;
    const pianoTechCustomerList = jsonResponse.pianoTechCustomerList;
    const pianoTechPianoList = jsonResponse.pianoTechPianoList;
    const pianoTechAppointmentList = jsonResponse.pianoTechAppointmentList;

    let selectedTechnicianId = 0;

    if (pianoTechnicianList && pianoTechnicianList.length > 0) {
        selectedTechnicianId = pianoTechnicianList[0].techniciansId;
    }

    return {
        type: LOGIN_VALIDATE_USER_SUCCESS,
        pianoTechCompany,
        maintenanceType,
        pianoTechnicianList,
        pianoTechCustomerList,
        pianoTechPianoList,
        pianoTechAppointmentList,
        selectedTechnicianId,
    }
}

function validateUserFailed(response) {
    const errorMessage = 'Failed to validate user.';

    return {
        type: LOGIN_VALIDATE_USER_FAILURE,
        message: errorMessage
    }
}

export function validateUser(loginId, password) {
    return async (dispatch) => {
        dispatch({ type: LOGIN_VALIDATE_USER_START });

        try {
            const response = await service.validateUser(loginId, password);
            dispatch(validateUserSucceeded(response, loginId));
        } catch (error) {
            dispatch(validateUserFailed(error));
        }
    };
}

